import React, { Component } from "react";
import _ from "lodash";
import { NotificationManager } from "react-notifications";

import ButtonGroup from "./ButtonGroup";
import ExhibitList from "./ExhibitList";
import ConfirmModal from "../../components/Modals/Confirm";
import SearchModal from "./SearchModal";

import ExhibitsAPI from "../../api/exhibits";
import TagsAPI from "../../api/tags";

class Exhibits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exhibits: [],
      showConfirmModal: false,
      selectedExhibitID: 0,
      showSearchModal: false,
      searchCriteria: ""
    };
  }

  componentDidMount() {
    this.getRecent();
  }

  getRecent = () => {
    this.setState({ searchCriteria: '' });
    ExhibitsAPI.getRecentUpdates().then(result => {
      this.formatData(result.data);
    });
  };

  toggleConfirmModal = (id = 0) => {
    const { showConfirmModal } = this.state;

    this.setState({
      selectedExhibitID: id,
      showConfirmModal: !showConfirmModal
    });
  };

  toggleSearchModal = () => {
    const { showSearchModal } = this.state;

    this.setState({
      showSearchModal: !showSearchModal,
      searchCriteria: '',
    });
  };

  deleteExhibit = () => {
    const { selectedExhibitID } = this.state;

    ExhibitsAPI.deleteExhibit(selectedExhibitID).then(() => {
      this.toggleConfirmModal();
      this.getRecent();
      NotificationManager.success("Exhibit deleted successfully");
    });
  };

  search = () => {
    const { searchCriteria } = this.state;

    ExhibitsAPI.search(searchCriteria).then(result => {
      this.formatData(result.data);
      this.toggleSearchModal();
    });
  };

  onCriteriaChange = e => {
    this.setState({ searchCriteria: e.target.value });
  };

  formatData = data => {
    const exhibits = [];

    data.map(d => {
      const index = _.findIndex(exhibits, obj => obj.exh_id === d.exh_id);
      if (index !== -1) {
        exhibits[index].tags.push({ tag_id: d.tag_id, tag_name: d.tag_name });
      } else {
        exhibits.push({
          exh_id: d.exh_id,
          exh_title: d.exh_title,
          exh_desc: d.exh_desc,
          exh_updated_at: d.exh_updated_at,
          tags: [
            {
              tag_id: d.tag_id,
              tag_name: d.tag_name
            }
          ]
        });
      }
    });

    this.setState({ exhibits });
  };

  render() {
    const {
      exhibits,
      showConfirmModal,
      showSearchModal,
      searchCriteria
    } = this.state;

    return (
      <div>
        <ConfirmModal
          show={showConfirmModal}
          toggle={this.toggleConfirmModal}
          title="Confirm Delete"
          confirm={this.deleteExhibit}
        >
          Are you sure you want to delete this exhibit?
        </ConfirmModal>
        <SearchModal
          show={showSearchModal}
          toggle={this.toggleSearchModal}
          search={this.search}
          searchCriteria={searchCriteria}
          onChange={this.onCriteriaChange}
          getRecent={this.getRecent}
        />
        <ButtonGroup showSearchModal={this.toggleSearchModal} />
        <ExhibitList
          exhibits={exhibits}
          deleteExhibit={this.toggleConfirmModal}
        />
      </div>
    );
  }
}

export default Exhibits;



// WEBPACK FOOTER //
// ./src/pages/Exhibits/index.jsx